import { FaSearch } from "react-icons/fa";
import logo from "../assets/blinkscribelogo.png";
import redmic from "../assets/redmic.png";
import Filtersdt from "./filters/filtersdt";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { debounce } from 'lodash'; 
import useModalStore from "zustand/zustandstore";
import api from "api/api";
import TableComponent from "./tables/table";
import { useDispatch } from "react-redux";
import { resetSettings, setProviders, setSavedload, setSelectedTab, setVisittype } from "../redux/store";
import { useSelector } from "react-redux";
import { Backdrop, CircularProgress } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import ToastMessage from "utils/muialerts/righttoptoast";
import AuthOverlayCard from "pages/landing/overlayauth/authoverlay";
import TermsOverlayCard from "pages/landing/overlayauth/termsoverlay";
import { convertToddmmyyy } from "utils/date";
import GoogleMeetflow from "googlemeet/googlemeet";
import { eventBus } from '../utils/eventbus/eventBus';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleQuestion } from "@fortawesome/free-solid-svg-icons";
import RaiseTicketAuth from "pages/auth/screens/raiseticketauth";
const SideBar = ({ isSidebarOpen, toggleSidebar,setSidebarOpen }) => {
  const [searchQuery, setSearchQuery] = useState('');
  const location =useLocation()
  const [result, setResult] = useState([]);
  const inputRef = useRef(null);
  const mydata = useModalStore();
  const mytabs = localStorage.getItem("mytab");
    const [ehrLoading,setEhrLoading]=useState(false)
    const department_id = localStorage.getItem("dp_id");
  const [loading, setLoading] = useState(false);
      const [loguser,setLoguser]=useState('')
        const [isverified,setIsVerified]=useState(0)
  const [ishelpmodal,setIsHelpModal]=useState(false)
        const[myimgurl,setMyimgUrl]=useState('')
        const latestImageUrl = useRef('');
    const [filteredData, setFilteredData] = useState([]);
  const dispatch = useDispatch();
  const [tab, setTab] = useState("ALL");
  const navigate=useNavigate()
  const [istableloading, setIstableLoading] = useState(false);
  const savedload = useSelector((state) => state.data.savedload);
    const { isOpen, openModal, closeModal,setModalValue } = useModalStore();
     const [alertmessage, setAlertMessage] = useState('');
      const [open, setOpen] = useState(false);
      const [severity, setSeverity] = useState('success');
      const targetRef = useRef(null);
const tooltipRef = useRef(null);


      const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
          return;
        }
        setOpen(false);
      }
    const [currentTimestamp, setCurrentTimeStamp] = useState({
      startDate: "",
      endDate: "",
      startTime: "",
      endTime: "",
    });
    let payload = {
      filter_array: {
        date_filter: {
          start_date: currentTimestamp.startDate,
          end_date: currentTimestamp.endDate,
          start_time: currentTimestamp.startTime,
          end_time: currentTimestamp.endTime,
        },
        
      },
      dash_filter: mytabs || "ALL",
      time_zone: Intl.DateTimeFormat().resolvedOptions().timeZone, // Adding the time zone here
    };
    const PAGE_SIZE = 20;
    const [hasMore, setHasMore] = useState(true);
    const [isLoadingMore, setIsLoadingMore] = useState(false);
    const searchtrigger = useRef();
    const [dashboardData, setDashboardData] = useState([]);
    const setSearchtrigger = (value) => {
      // Setting the ref value
  
      searchtrigger.current = value;
    };
    const fetchdashboardData = async () => {
      let obj = JSON.parse(JSON.stringify(payload));
      dispatch(setSavedload({ ...obj }));
      try {
        setIstableLoading(true);
        setHasMore(true);
  
        const response = await api.get("/auth/me");
        let apiresp;
        if (response && response.config && response.config.user_type) {
          if (response.config.user_type === "BUSINESS") {
            apiresp = await api.post("/v1/business/recording/dashboard", payload);
          } else if (response.config.user_type === "PRO") {
            apiresp = await api.post("/v1/appointments/dashboard", {
              ...payload,
              offset: 0,
              limit: PAGE_SIZE,
            });
          } else {
            apiresp = await api.post("/v1/basic/recording/dashboard", payload);
          }
        }
  
        if (apiresp && apiresp.status === 200) {
          const records = apiresp.data || [];
          setDashboardData(records);
          const totalCount = apiresp.actual_count !== undefined ? apiresp.actual_count : (apiresp.totalcount !== undefined ? apiresp.totalcount : records.length);
          setHasMore(records.length < totalCount && records.length >= PAGE_SIZE);
        } else {
          setDashboardData([]);
          setHasMore(false);
        }
      } catch (error) {
        console.log(error);
        setHasMore(false);
      } finally {
        setIstableLoading(false);
      }
    };

    const loadMoreAppointments = async () => {
      if (isLoadingMore || istableloading || !hasMore || mydata?.usertype !== 'PRO') return;
      try {
        setIsLoadingMore(true);
        const currentOffset = dashboardData.length;
        const apiresp = await api.post("/v1/appointments/dashboard", {
          ...payload,
          offset: currentOffset,
          limit: PAGE_SIZE,
        });
        if (apiresp && apiresp.status === 200) {
          const newRecords = apiresp.data || [];
          if (newRecords.length > 0) {
            setDashboardData((prev) => {
              const existingIds = new Set(prev.map((r) => r.appointmentid));
              const filteredNew = newRecords.filter((r) => !existingIds.has(r.appointmentid));
              return [...prev, ...filteredNew];
            });
          }
          const totalCount = apiresp.actual_count !== undefined ? apiresp.actual_count : (apiresp.totalcount !== undefined ? apiresp.totalcount : 0);
          if (newRecords.length < PAGE_SIZE || (currentOffset + newRecords.length) >= totalCount) {
            setHasMore(false);
          }
        } else {
          setHasMore(false);
        }
      } catch (error) {
        console.log(error);
        setHasMore(false);
      } finally {
        setIsLoadingMore(false);
      }
    };

    const handleScroll = (e) => {
      const { scrollTop, scrollHeight, clientHeight } = e.target;
      if (scrollTop > 0 && scrollHeight - scrollTop - clientHeight < 60) {
        if (hasMore && !isLoadingMore && !istableloading && mydata?.usertype === 'PRO') {
          loadMoreAppointments();
        }
      }
    };
      const fetchuser=async ()=>{
        try {
          const response = await api.get('/auth/me')
          setLoguser(response)
          if(response?.bm_user){
            if(response?.disclaimer=='PENDING'){
    setIsVerified(2)
            }else{
              setIsVerified(0)
            }
          }else{
            setIsVerified(1)
          }
        
        } catch (error) {
          
        }
        }
        function checkImage(url, onSuccess, onError) {
          const img = new Image();
        
          img.onload = function () {
            onSuccess();
          };
        
          img.onerror = function () {
            onError();
          };
        
          img.src = url;
        }
        useEffect(() => {
          if (
            mydata?.usertype === 'PRO' &&
            mydata.screen === 0 &&
            Object.keys(mydata?.selectedRecord || {}).length === 0 &&
            location.pathname === '/v2' &&
          dashboardData?.length!==0&&
            targetRef.current &&
            tooltipRef.current
          ) {
            const rect = targetRef.current.getBoundingClientRect();
            const tooltip = tooltipRef.current;
        
            tooltip.style.position = 'absolute';
            tooltip.style.top = `${rect.top + window.scrollY+45}px`;
            tooltip.style.left = `100%`; // Or adjust based on arrow direction
          }
        }, [mydata, location.pathname,dashboardData]);

        useEffect(() => {
        
        
          if (typeof loguser === 'object' && loguser !== null && mydata?.selectedRecord?.patientid) {
            const imageUrl = `https://api.prd.brainymed.com/bs/patient-profile-pictures/${loguser?.config?.practiceid}/${mydata.selectedRecord?.patientid}.png`;
        
            latestImageUrl.current = imageUrl;
        
            checkImage(
              imageUrl,
              () => {
                // Only update state if the image URL hasn't changed since the request started
                if (latestImageUrl.current === imageUrl) {
                  setMyimgUrl(true);
                }
              },
              () => {
                if (latestImageUrl.current === imageUrl) {
                  setMyimgUrl(false);
                }
              }
            );
          }
        }, [mydata, loguser]);
    const loaddashboardData = async () => {
      try {
        const response = await api.get("/auth/me");
        let apiresp;
        if (response && response.config && response.config.user_type) {
          if (response.config.user_type === "BUSINESS") {
            apiresp = await api.post("/v1/business/recording/dashboard", payload);
          } else if (response.config.user_type === "PRO") {
            apiresp = await api.post("/v1/appointments/dashboard", {
              ...payload,
              offset: 0,
              limit: PAGE_SIZE,
            });
          } else {
            apiresp = await api.post("/v1/basic/recording/dashboard", payload);
          }
        }
  
        if (apiresp && apiresp.status === 200) {
          const records = apiresp.data || [];
          setDashboardData(records);
          const totalCount = apiresp.actual_count !== undefined ? apiresp.actual_count : (apiresp.totalcount !== undefined ? apiresp.totalcount : records.length);
          setHasMore(records.length < totalCount && records.length >= PAGE_SIZE);
        } else {
          setDashboardData([]);
          setHasMore(false);
        }
      } catch (error) {
        console.log(error);
      }
    };
  
    useEffect(() => {
      // Automatic polling removed per user request to stop excessive calls.
      // loaddashboardData will still be called via events or manual triggers.
    }, []);
  useEffect(() => {
    // Listen for 'refreshDashboard' event
    eventBus.on('refreshDashboard', loaddashboardData);

    return () => {
      // Clean up on unmount
      eventBus.removeAllListeners('refreshDashboard');
    };
  }, []);
    useEffect(() => {
      if (mydata?.trigger) {
        fetchdashboardData();
      }
    }, [mydata?.trigger]);
    useEffect(() => {
      if (currentTimestamp.startDate) {
        fetchdashboardData();
      }
    }, [currentTimestamp]);
    useEffect(() => {
      setTab(mytabs);
      fetchuser()
    }, []);
    const handleTabs = (x) => {
      setTab(x);
      localStorage.setItem("mytab", x);
      payload.dash_filter = x;
      dispatch(setSelectedTab("PENDING"));
      fetchdashboardData();
      // payload.dash_filter = "ALL";
    };
    const handleScribeFilter = async (patient_id) => {
      if (!patient_id) {
        return;
      }
      let obj = JSON.parse(JSON.stringify(payload));
      obj.search_filter = `${patient_id}`;
      obj.time_zone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      try {
        setLoading(true);
        const endpoint =
          mydata.usertype === "BUSINESS"
            ? "/v1/business/recording/dashboard"
            : mydata.usertype === "PRO"
            ? "/v1/appointments/dashboard"
            : "/v1/basic/recording/dashboard";
  
        // const response=await api.post('/v1/basic/recording/dashboard',obj)
        const response = await api.post(endpoint, obj);
        if (response.status === 200) {
          setDashboardData(response.data);
        } else {
          setDashboardData([]);
        }
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    };
    const handletimeStamp = (stamp) => {
      setCurrentTimeStamp(stamp);
    };
    const stampformater = async () => {
      const today = new Date().toISOString().split("T")[0]; // Get current date in YYYY-MM-DD format
      // const startTime ="04:00:00.000Z"; // Initial start time
      // const endTime = "19:00:00.000Z"; // Initial end time
      const startTime = "00:00:00.000Z"; // 12:00 AM UTC
const endTime = "23:59:59.000Z";   // 11:59:59 PM UTC (close to 12 AM next day)

      const dateFilter = savedload?.filter_array?.date_filter;
      const weekBack = new Date();
      weekBack.setDate(weekBack.getDate() - 7);
  
      // Format the weekBack date in YYYY-MM-DD format
      const weekBackFormatted = weekBack.toISOString().split("T")[0];
  
      if (!dateFilter || !dateFilter.start_date || !dateFilter.end_date) {
        // If user is 'BASIC', set start date to 7 days before today
        const startDate =
          mydata?.usertype === "BASIC" || mydata?.usertype === "PLUS"
            ? weekBackFormatted
            : today;
  
        setCurrentTimeStamp({
          startDate: startDate,
          endDate: today,
          startTime: startTime,
          endTime: endTime,
        });
      } else {
        setCurrentTimeStamp({
          startDate: dateFilter.start_date,
          endDate: dateFilter.end_date,
          startTime: dateFilter.start_time,
          endTime: dateFilter.end_time,
        });
      }
    };
  
    useEffect(() => {
      stampformater();
    }, []);
    useEffect(() => {
      payload = savedload;
    }, []);
  const fetchSearchResults = useCallback(
    debounce(async (query) => {
      if (!query) {
        setResult([]);
        return;
      }

      try {
        const response = await api.post(
          `/v1/${
            mydata.usertype === 'BUSINESS' 
              ? 'business/recording' 
              : mydata.usertype === 'PRO' 
              ? 'appointments' 
              : 'basic/recording'
          }/search/suggestions`,
          {
            search_filter: query,
            filter_array: payload?.filter_array,
            time_zone: Intl.DateTimeFormat().resolvedOptions().timeZone
          }
        );
        ;

        if (response.status === 200 && response.data) {
          setResult(response.data);
        }
      } catch (error) {
        console.error('Error fetching search results:', error);
      }
    }, 500),
    [payload]
  );

  const handleSearch = (e) => {
    const query = e.target.value.toLowerCase();
    setSearchQuery(query);
    if (query) {
      fetchSearchResults(query);
    } else {
      setResult([]);
    }
  };

  const handleOutsideClick = (e) => {
    if (inputRef.current && !inputRef.current.contains(e.target)) {
      setResult([]);
    }
  };

  React.useEffect(() => {
    document.addEventListener('click', handleOutsideClick);
    return () => {
      document.removeEventListener('click', handleOutsideClick);
    };
  }, []);

  const today = new Date();
  const yesterday = new Date();
  yesterday.setDate(today.getDate() - 1);

  const formatDate = (date) => date.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });

  const categorizeRecords = () => {
    const todayRecords = [];
    const yesterdayRecords = [];
    const previousRecords = [];

    dashboardData.forEach((item) => {

      let date= mydata.usertype==='PRO'?item?.startdate:item?.ts

      const itemDate = new Date(date);

      if (itemDate.toDateString() === today.toDateString()) {
        todayRecords.push(item);
      } else if (itemDate.toDateString() === yesterday.toDateString()) {
        yesterdayRecords.push(item);
      } else {
        previousRecords.push(item);
      }
    });
    return { todayRecords, yesterdayRecords, previousRecords };
  };

  const { todayRecords, yesterdayRecords, previousRecords } = categorizeRecords();
  const handleRecordType = (providers, purpose, filterstate) => {
    if (!filteredData.length) {
      return;
    }
    
    if (providers.length) {
      payload.filter_array.providername = providers;        
     //dispatch(resetSettings())
      dispatch(setProviders(providers))
    }
    if (purpose.length) {
      payload.filter_array.purpose = purpose;
      dispatch(setVisittype(purpose))
    }
    if (filterstate) {
      if (purpose.length && !providers.length) {
        delete payload.filter_array.providername;
        dispatch(resetSettings())
        dispatch(setProviders([]))
        dispatch(setVisittype(purpose))
      } else if (!purpose.length && providers.length) {
        delete payload.filter_array.purpose;
        
        dispatch(resetSettings())
        dispatch(setVisittype([]))
        dispatch(setProviders(providers))
      } else if (!purpose.length && !providers.length) {
        delete payload.filter_array.providername;
        delete payload.filter_array.purpose;
        dispatch(resetSettings())
      }
      if (filterstate) {
  fetchdashboardData()   
        return; 
      }
    }
  };
    const fetchEhr = async (x) => {
      try {
     
        setEhrLoading(true)
  if(loguser?.config&&loguser?.config?.ehrid=='3'){
  
    const response=  await api.post("/v1/ehr/appointments/sync", {
      "practitioner":loguser?.config?.practitioner,
  "date": {
          "ge": `${currentTimestamp.startDate}T00:00:00`,"lt":`${currentTimestamp.endDate}T23:59:00`
      }
    });
    if(response.status==200){
      setAlertMessage(
        `${response.new_appointments} New Appointment${
          response.new_appointments === 1 ? "" : "s"
        } Found`
      );
      
      setSeverity(severity);
      setOpen(true);
    }else{
      setAlertMessage(`0 New Appointments Found`);
      setSeverity(severity);
      setOpen(true);
    }
    return
  
  }else{
  
    const response=  await api.post("/v1/ehr/appointments/sync", {
        department_id: department_id,
        "start_date":currentTimestamp.startDate,
         "end_date":currentTimestamp.endDate
      });
      if(response.status==200){
        setAlertMessage(
          `${response.new_appointments} New Appointment${
            response.new_appointments === 1 ? "" : "s"
          } Found`
        );
        
        setSeverity(severity);
        setOpen(true);
      }else{
        setAlertMessage(`0 New Appointments Found`);
        setSeverity(severity);
        setOpen(true);
      }
  }
  
        await api.post('/v1/ehr/providers/sync')
      const response=  await api.post("/v1/ehr/appointments/sync", {
          department_id: department_id,
          "start_date":currentTimestamp.startDate,
           "end_date":currentTimestamp.endDate
        });
  
        await api.post('/v1/ehr/appointment-patients/sync',{
          department_id: department_id,
          "start_date":currentTimestamp.startDate,
           "end_date":currentTimestamp.endDate
        })
     
      } catch (error) {
        console.log(error)
      }finally{
    setEhrLoading(false)

  await fetchdashboardData();
  //setShowCount(false)
      }
  
      
    }
    useEffect(() => {
        setFilteredData(dashboardData);
    }, [dashboardData]);
    const showTooltip =
  mydata?.usertype === 'PRO' &&
  mydata.screen === 0 &&
  Object.keys(mydata?.selectedRecord || {}).length === 0 &&
  location.pathname === '/v2' &&
  dashboardData?.length !== 0;
  return (<>
 <div
    className={`
  fixed sm:relative top-0 left-0 z-40 h-screen
  transform transition-transform duration-300 ease-in-out
  ${isSidebarOpen ? "translate-x-0" : "-translate-x-full"} sm:translate-x-0
  w-full sm:w-[20%] bg-white shadow-md
  flex flex-col items-center justify-start pr-4 pl-2 py-4 gap-4
  ${mydata.recording ? "pointer-events-none" : ""}
`}
      >
        {/* Mobile Close Button */}
        <div className="sm:hidden w-full flex justify-end mb-2">
          <button onClick={toggleSidebar} className="text-xl font-bold px-3 py-1">✕</button>
        </div>

        {/* Your original sidebar content */}
        <div className="w-full flex flex-col justify-center items-center">
          <img
            onClick={() => {
              setModalValue({ screen: 0 });
              setModalValue({ selectedRecord: {} });
              navigate('/v2');
            }}
            src={logo}
            alt="BlinkScribe Logo"
            className="w-36 mx-auto cursor-pointer"
          />
          <div className="w-full">{mydata.usertype}</div>
        </div>

        {/* Search Bar */}
        <div className="relative w-full">
          <div className="flex items-center w-full px-3 py-2 rounded-md border border-gray-300 bg-gray-100">
            <FaSearch className="text-gray-500" />
            <input
              placeholder={mydata.usertype !== 'BUSINESS' ? "Search Patient by Name or ID" : "Search Conversations"}
              value={searchQuery}
              onChange={(e) => {
                setSearchtrigger(e.target.value);
                handleSearch(e);
              }}
              type="text"
              className="w-full bg-transparent outline-none pl-2 text-gray-700"
            />
            {searchQuery && (
              <button
                className="ml-2 text-gray-500 hover:text-black"
                onClick={() => {
                  setSearchQuery('');
                  setResult([]);
                  setSearchtrigger('');
                  fetchdashboardData();
                }}
              >✕</button>
            )}
          </div>

          {/* Search Results Dropdown */}
          {result.length > 0 && searchQuery && (
            <ul className="absolute w-full mt-1 bg-white border border-solid border-[#DCDFE3] rounded-lg max-h-40 overflow-y-auto shadow-lg z-10 custom-scrollbar">
              {result.map((record) => (
                <li key={record.patientid} className="p-2 text-left hover:bg-gray-200 cursor-pointer" onClick={() => {
                  setSearchQuery(mydata.usertype === 'BUSINESS' ? record.name : record.patient_name);
                  handleScribeFilter(mydata.usertype === 'BUSINESS' ? record.id : record.patient_name);
                  setResult([]);
                }}>
                  {mydata.usertype === 'BUSINESS' ? `${record.name} - ${record.id}` : `${record.patient_name} - ${record.patientid}`}
                </li>
              ))}
            </ul>
          )}
        </div>

        {/* Filters and Table Sections */}
        <Filtersdt
          handleTabs={handleTabs}
          
          originaldata={dashboardData}
          tab={tab}
          fetchEhr={fetchEhr}
          setTab={setTab}
          handleRecordType={handleRecordType}
          handletimeStamp={handletimeStamp}
          filteredData={filteredData}
        />

        {showTooltip && (
          <div ref={tooltipRef} className="absolute top-[43%] left-[100%] hidden sm:block">
            <div className="relative inline-flex items-center shadow-md">
              <div className="bg-[#418CFF] text-white text-sm rounded-md px-3 py-2 w-max z-10">Select a patient</div>
              <div className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-full z-50">
                <div className="w-0 h-0 border-t-8 border-b-8 border-r-[12px] border-t-transparent border-b-transparent border-r-[#418CFF]"></div>
              </div>
            </div>
          </div>
        )}

        {/* Record Lists */}
        <div ref={targetRef} onScroll={handleScroll} className="w-full relative overflow-auto max-h-96">
          {[{ title: "Today", data: todayRecords }, { title: "Yesterday", data: yesterdayRecords }, { title: "Previous Days", data: previousRecords }].map(({ title, data }) => (
            <TableComponent
              key={title}
              title={title}
              data={data}
              setSidebarOpen={setSidebarOpen}
              mydata={mydata}
              selectedRecord={mydata.selectedRecord}
              formatDate={formatDate}
              toggleSidebar={toggleSidebar}
              setLoading={setLoading}
              loading={loading}
            />
          ))}
          {isLoadingMore && (
            <div className="w-full flex justify-center items-center py-2 text-xs text-gray-500 gap-2">
              <CircularProgress size={16} />
              <span>Loading more appointments...</span>
            </div>
          )}
        </div>

        {/* Bottom Buttons */}
        <div className="w-full flex flex-wrap justify-center gap-4">
          {(!location.pathname.startsWith('/v2') || mydata.screen === 1) && mydata.usertype !== 'PRO' && (
            <button
              onClick={() => {
                setModalValue({ screen: 0 });
                setModalValue({ selectedRecord: {} });
                navigate('/v2');
              }}
              className={`w-full  sm:w-auto sm:min-w-[45%] ${mydata.usertype === 'BUSINESS' } py-3 px-2 text-xs bg-[#1C2A3A] text-white font-medium rounded-lg flex items-center justify-center shadow-md hover:shadow-lg transform hover:scale-105 transition-transform duration-200`}
            >
              Start Recording
            </button>
          )}

          {mydata.usertype !== 'BUSINESS' && loguser?.config && (
            <button
              onClick={() => {
                if (mydata.usertype === 'PRO') {
                  loguser?.config?.ehrid === '3' ? navigate('/temp') : navigate('/manage-template');
                } else {
                  navigate('/temp');
                }
                   if (window.innerWidth < 640) {
        toggleSidebar();
      }
              }}
              className={`w-full sm:min-w-[45%] ${(!location.pathname.startsWith('/v2') || mydata.screen === 1) && mydata.usertype !== 'PRO'?" sm:w-auto":'w-full'}  py-3 px-2 text-xs bg-[#1C2A3A] text-white font-medium rounded-lg flex items-center justify-center shadow-md hover:shadow-lg transform hover:scale-105 transition-transform duration-200`}
            >
              Manage Templates
            </button>
          )}

          {mydata.usertype === 'BUSINESS' && <GoogleMeetflow />}
        </div>
      </div>
    {ishelpmodal?<RaiseTicketAuth setModal={setIsHelpModal} setOpen={setOpen} setTMessage={setAlertMessage} setSeverity={setSeverity} ismodal={ishelpmodal} data={mydata}/>:<></>}
    
     <ToastMessage message={alertmessage} severity={severity} open={open} handleClose={handleClose} />
          {isverified==1&&<AuthOverlayCard handleVerified={fetchuser} isOpen={true}/>}
          {isverified==2&&<TermsOverlayCard handleVerified={fetchuser} isOpen={true}/>}
    <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading || ehrLoading || (istableloading && dashboardData.length === 0)}
      >
        <CircularProgress color="inherit" size={40} />
      </Backdrop>
    </>
  );
};

export default SideBar;